import React, { ReactElement, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../components/CiscoUi';
import { NotifyPanel } from '../../../components';
import { AuthStatusValues } from '../../../auth';
import { NotAuthorizedGenericErrorProps } from './container';

export function NotAuthorizedGenericError({
  setAuthStatus,
}: NotAuthorizedGenericErrorProps): ReactElement {
  const history = useHistory();

  useEffect(() => {
    setAuthStatus(AuthStatusValues.NotAuthenticated);
  }, [setAuthStatus]);

  return (
    <NotifyPanel
      callToAction={
        <Button
          className="base-margin-top base-margin-bottom"
          colour="success"
          onClick={() => history.push('/')}
          size="large"
          testId="not-authorized-generic-error-page-cta"
        >
          Return to Topology Builder
        </Button>
      }
      heading="Topology Builder"
      subHeading="Sorry, something went wrong. Please try again"
    />
  );
}
